import { useCallback } from 'react';
import { keepPreviousData } from '@tanstack/react-query';

import { SchedulerWebHook, SchedulerWebHookId } from '@playq/services-jobot-scheduler';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

export const webHookGetKeys: unknown[] = ['admin', 'webhook', 'get'];

export const useWebHookGet = (
  id?: SchedulerWebHookId,
  options?: IUseQueryOptionsExtended<SchedulerWebHook | undefined, GenericFailure | Error>
) => {
  const { mutate, ...res } = useEitherQuery(
    webHookGetKeys.concat(id),
    () => {
      if (id) {
        return services2.intergrationsWebHookService.retrieve(id);
      }
    },
    {
      placeholderData: keepPreviousData,
      ...options,
    }
  );

  const mutateDeletedWebhook = useCallback(
    (webHook: SchedulerWebHook) => {
      if (res.data) {
        mutate(webHook);
      }
    },
    [mutate, res.data]
  );

  return {
    webHook: res.data,
    ...res,
    mutate,
    mutateDeletedWebhook,
  };
};
